import categoryRequests from '@/services/admin/category-service';
import providesRequests from '@/services/admin/provider-service';
export const serviceFormLookupsRepository = {
    async getAssignableCategories() {
        const response = await categoryRequests.getAssignableCategories();
        return Array.isArray(response.data) ? response.data : [];
    },
    async getProviders() {
        const response = await providesRequests.getAllProvider();
        return Array.isArray(response.data) ? response.data : [];
    },
};
